class TokenUtil {
    constructor() {
        this.isProcessing = false;
        this.queue = [];
    }



    prepareHeaders(reqParam, contentType, acceptType, token) {
        const headers =
            reqParam instanceof FormData
                ? {
                    "x-api-key": "web",
                }
                : {
                    Accept: acceptType,
                    "x-api-key": "web",
                    "Content-Type": contentType,
                };
        // Only attach Authorization when a token is actually present. A tokenless
        // (public) call then sends NO Authorization header at all, instead of
        // "Authorization: null" — so a stale/expired token can't break it.
        if (token) {
            headers.Authorization = token;
        }
        return headers;
    }

    async updateToken() {
        this.isProcessing = false;
        this.queue = [];
        return null;
    }

    async getBearerToken() {
        try {
            let token = localStorage.getItem("BearerToken")
            if (token == null) {
                return null;
            }
            return token;
        } catch (error) {
            console.error('Error processing function:', error);
        }
    }

    async callAPI({ endPoint, method, reqParam = {}, token }) {
        const acceptType = "application/json";
        const contentType = reqParam instanceof FormData ? "multipart/form-data" : "application/json";
        let response = null;
        try {
            let content = {
                method: method,
                headers: this?.prepareHeaders(reqParam, contentType, acceptType, token),
            };

            if (method === "POST" || method === "DELETE" || method === "PATCH" || method === "PUT") {
                content = { ...content, body: reqParam instanceof FormData ? reqParam : JSON?.stringify(reqParam) };
            }

            if (reqParam instanceof FormData) {
                let headers = this?.prepareHeaders(reqParam, contentType, acceptType, token);
                response = await fetch(endPoint, { method, body: reqParam, headers });
            } else {
                response = await fetch(endPoint, content);
            }
        } catch (e) {
            console.log(e, 'error');
        }

        if (response) {
            if (response.status === 204) {
                return {
                    data: { message: "success" },
                    status: response.status,
                    statusText: response.statusText,
                    headers: response.headers,
                };
            }

            if (response.status === 413) {
                return {
                    data: { message: "Size Too Large" },
                    status: response.status,
                    headers: response.headers,
                };
            }

            const responseContentType = response.headers.get("Content-type");

            let data = null;

            if (responseContentType === null) data = { message: "success" }
            else if (responseContentType === "application/json" || responseContentType?.includes("application/json"))
                data = await response.json();
            else if (responseContentType.includes("text/plain"))
                data = await response.text();
            else if (responseContentType.includes("application/zip"))
                data = await response.blob();
            else if (responseContentType === "application/pdf") {
                data = await response.blob();
            } else if (responseContentType === "application/vnd.ms-excel") {
                data = new Blob([await response.blob()], { type: responseContentType });
            } else if (responseContentType === "application/zip") {
                data = await response.blob();
            }
            response = {
                data: data,
                status: response?.status,
                statusText: response?.statusText,
                headers: response.headers,
            };
        }

        return response;
    };

}

export const tokenUtil = new TokenUtil();
